// `active` is the default working list. Its behavior lives elsewhere: the sync
// excludes archived server-side (buildConversationListSearch) and drops every
// thread whose contact holds an opt-out record client-side (partitionByOptOut),
// including contacts who texted in again after opting out. Those threads are
// under the `opted_out` filter, still badged and still unsendable.
// `replied` is `active` narrowed to threads the contact has actually written into:
// the search returns inbound messages only, so every aggregated row holds at least
// one. Archived is excluded by the same default branch, opted out by partitionByOptOut.
// `scheduled` is the inverse of every other filter: it is the only one that shows
// held messages, the ones a future sendDate keeps out of the sent timeline.
/** The vocabulary, in the order the filter menu shows it. */
export const INBOX_FILTER_OPTIONS = [
  `active`,
  `unread`,
  `replied`,
  `ai_agent`,
  `scheduled`,
  `opted_out`,
  `archived`,
] as const

/** Derived from the array above, so adding a filter there is the only edit needed. */
export type InboxFilterOption = (typeof INBOX_FILTER_OPTIONS)[number]

/** Narrows a persisted setting, which can be stale or hand-edited, to a filter we still support. */
export function isInboxFilterOption(value: unknown): value is InboxFilterOption {
  // Widened to unknown[] rather than casting `value`: the tuple's own element
  // type is the union this is still deciding, so `includes` would reject the
  // very argument it exists to test.
  return (INBOX_FILTER_OPTIONS as readonly unknown[]).includes(value)
}

/**
 * Which stored filter, if any, the inbox should open with.
 *
 * A link carrying a filter is someone pointing at a list, so it outranks what
 * this user last chose. `active` is the default and carries no parameter, so
 * there is nothing to restore for it either.
 */
export function filterToRestore(urlSpecifiedFilter: boolean, stored: unknown): InboxFilterOption | undefined {
  if (urlSpecifiedFilter) return undefined
  if (!isInboxFilterOption(stored) || stored === `active`) return undefined
  return stored
}
